//////LIBRARY//////
import React, { Fragment, useState, useEffect, useMemo } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
import { languagesManagerActionCreators, tableActionCreators } from '../../store/actions'
import { cloneDeep, isEmpty, isUndefined, find } from 'lodash'
import { Link, useHistory } from 'react-router-dom'
//////COMPONENTS//////
import { uriList } from '../../routings/settings/RouteList'
import Table from '../../components/Table'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import Button from '../../components/Ui/Buttons'
import theme from '../../theme/theme'
import Tooltip from '../../components/Tooltip/Tooltip'
import userPrivileges from '../../constants/PrivilegesList'
import { ButtonWrapper, TextModal } from '../../theme/GlobalCss'
import Modals from '../../components/Modals'
import StringFormatter from '../../helpers/StringFormatter'
import allReplace from '../../helpers/allReplace'
//////ASSETS//////
import EnabledLanguageIcon from '../../assets/icones/languagesManager/check-big-circle-green.svg'
import DisabledLanguageIcon from '../../assets/icones/languagesManager/cross-big-circle-red.svg'
import AddButton from '../../assets/icones/global/add.svg'
import CloseButtonIcon from '../../assets/icones/global/close-white.svg'
import ValidateButtonIcon from '../../assets/icones/global/check.svg'
import TableTitle from '../../components/Table/components/TableTitle'

//////STYLED//////
const LanguagesManagerWrapper = styled.div`
	position: relative;
`
const LanguagesManagerCreateButton = styled(Link)`
	width: 32px;
	height: 32px;
	border-radius: 16px;
	background-color: ${(props) => props.theme.colors.primary};
	background-image: url(${AddButton});
	background-repeat: no-repeat;
	background-position: center;
	position: absolute;
	right: 0;
	top: -67px;
	cursor: pointer;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
//////STYLED//////

const LanguagesManager = () => {
	const { user, translations, languagesManager, currentColumn, currentDir } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			userKioskPerimeter: state.user.identity.kioskSelected,
			languagesManager: state.languagesManager,
			userRolePrivileges: state.user.identity.rolePrivileges,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	const actionsLanguagesManager = bindActionCreators(languagesManagerActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	let history = useHistory()

	const [row, setRow] = useState()
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'enabled', nameDir: 'desc', sort_2: 'labelEnglish', nameDir_2: 'asc' })
	const [configTable, setConfigTable] = useState({})
	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {},
		paging: {
			fnSendTo: (paging) => handlePagingLanguagesManager(paging),
		},
	})

	const [columns, setColumns] = useState([])

	const [showModalDeactivateLanguage, setShowModalDeactivateLanguage] = useState(false)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleDeactivateModal = (row) => {
		setRow(row)
		setShowModalDeactivateLanguage(true)
	}

	const handleCloseModals = () => {
		if (showModalDeactivateLanguage) setShowModalDeactivateLanguage(false)
	}

	const handleDeactivateLanguage = (id) => {
		actionsLanguagesManager.putLanguageEnabling(id, false)
	}

	const handlePagingLanguagesManager = (paging) => {
		let sortMap = {}
		if (!isUndefined(currentColumn.value)) {
			sortMap = {
				sort: currentColumn.value,
				nameDir: currentDir.value,
			}
		} else {
			sortMap = {
				sort: 'enabled',
				nameDir: 'desc',
				sort_2: 'labelEnglish',
				nameDir_2: 'asc',
			}
		}
		const pg = { ...paging, ...sortMap }
		setPaging(pg)
		actionsLanguagesManager.getLanguages({}, pg)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		return function cleanUp() {
			actionsLanguagesManager.resetDataLanguagesManager()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(languagesManager) && !isUndefined(languagesManager)) {
			cfg.paging = {
				totalElements: languagesManager.paging.totalElements,
				totalPages: languagesManager.paging.totalPages,
				fnSendTo: (paging) => handlePagingLanguagesManager(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [languagesManager])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.name = translations['page__languagesManagement__languagesTable_title']

		setColumns([
			{
				columnReferential: 'language_language',
				dataHook: 'labelEnglish',
				headerName: translations['page__languagesManagement__languagesTable_language'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'labelEnglish',
			},
			{
				columnReferential: 'language_localLanguage',

				dataHook: 'labelLocal',
				headerName: translations['page__languagesManagement__languagesTable_localLanguage'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'labelLocal',
			},
			{
				columnReferential: 'language_flagLanguage',
				dataHook: 'picturePath',
				headerName: translations['page__languagesManagement__languagesTable_countryFlag'],
				sortable: true,
				isAuthorize: true,
				component: (props) => <img src={`/${props.row.picturePath}`} />,
				sortableId: 'picturePath',
			},
			{
				columnReferential: 'language_status',
				dataHook: 'enabled',
				headerName: translations['page__languagesManagement__languagesTable_status'],
				sortable: true,
				isAuthorize: true,
				component: (props) => <img src={props.row.enabled ? EnabledLanguageIcon : DisabledLanguageIcon} />,
				sortableId: 'enabled',
			},
			{
				columnReferential: 'language_translationNumber',
				dataHook: 'nbTranslation',
				headerName: translations['page__languagesManagement__languagesTable_nbTranslation'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'translations.size',
			},
			{
				columnReferential: 'language_defaultLanguage',
				dataHook: 'defaultLanguage',
				headerName: translations['page__languagesManagement__languagesTable_defaultLanguage'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (props.row.defaultLanguage ? translations['common__text__yes'] : '-'),
				sortableId: 'defaultLanguage',
			},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				withIcons: false,
				rest: {
					tooltipPart: 'languagesManager',
					paperActionsList: [
						{
							//iconDef: EditLanguageIcon,
							name: translations['tooltip__admin__languagesManagement_modifyLanguage'],
							translationKey: 'tooltip__admin__languagesManagement_modifyLanguage',
							clickAction: (row) => {
								history.push(`${uriList.languages}${uriList.languagesManager}${uriList.languagesManagerEdit}/${row.id}`)
							},
							isVisible: (row) => true,
						},
						{
							translationKey: 'tooltip__admin__languagesManagement_disableLanguage',
							name: translations['tooltip__admin__languagesManagement_disableLanguage'],
							clickAction: (row) => {
								handleDeactivateModal(row)
							},
							isVisible: (row) => !row.defaultLanguage && row.enabled,
							//icon: DeleteLanguageIcon,
						},
					],
				},
				checkRight: userPrivileges.action[15],
			},
		])

		//setConfig(cfg)
		setConfigTableTitle(cfg)
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 24,
		labelPageTable: 'language',
	}

	// On loading page
	useEffect(() => {
		if (isUndefined(translations) || isUndefined(user)) return
		if (isEmpty(languagesManager?.paging?.content) && !isEmpty(translations)) {
			actionsLanguagesManager.getLanguages()
		}
	}, [user, translations])
	useEffect(() => {
		if (showModalDeactivateLanguage) {
			handleCloseModals()
		}
	}, [languagesManager.items])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={languagesManager.items}
				inputConfig={configTable}
				isLoading={languagesManager.isLoading}
				currentPaging={paging}
				tableReferential={tableReferential}
				actionSort={actionsLanguagesManager.getLanguages}
			/>
		)
	}, [languagesManager, columns, configTable, translations, paging])

	return (
		<Fragment>
			<Modals
				title={translations['modal__languagesManagement__title__disableLanguage']}
				closeModalHandler={handleCloseModals}
				showModal={showModalDeactivateLanguage}
				level="error"
				icon={true}
			>
				<TextModal>
					<p
						dangerouslySetInnerHTML={{
							__html: StringFormatter.ResponseMessageParser(
								allReplace(translations['modal__languagesManagement__body__disableLanguage'], '\\\\n', '<br>'),
								[`<span style="color:${theme.colors.primary};">${row?.labelLocal}</span>`]
							),
						}}
					></p>
				</TextModal>
				<ButtonWrapper>
					<Button
						actionHandler={handleCloseModals}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={CloseButtonIcon}
					/>

					<Button
						actionHandler={() => handleDeactivateLanguage(row?.id)}
						text={translations['modal__languagesManagement__body__disableLanguage_confirm']}
						bgColor={theme.colors.validation}
						img={ValidateButtonIcon}
					/>
				</ButtonWrapper>
			</Modals>
			<LanguagesManagerWrapper>
				{!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[15])) && (
					<Tooltip tooltipId={'addButton'} translationsKey={'tooltip__admin__languagesManagement__createLanguage'}>
						<LanguagesManagerCreateButton to={`${uriList.languages}${uriList.languagesManager}${uriList.languagesManagerCreate}`} />
					</Tooltip>
				)}
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</LanguagesManagerWrapper>
		</Fragment>
	)
}

LanguagesManager.propTypes = {}

LanguagesManager.defaultPropTypes = {}

export default LanguagesManager
